// First observed acquisition in this browser (30-day window). No click IDs,
// full referrer URLs, search terms, or personal data are collected here.
const KEY = 'kundlistar-registration-attribution-v1';
interface Attribution { captured_at: number; platform: 'web'; source: string; evidence: 'web_first_visit'; referrer_host: string | null; landing_path: string | null; utm: Record<string, string | null> }
const clean = (value: string | null) => value && /^[a-zA-Z0-9_. -]{1,100}$/.test(value) ? value : null;
export function captureRegistrationAttribution(): void {
  try {
    const old: Attribution | null = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (old?.captured_at && Date.now() - old.captured_at < 30 * 86400000) return;
    const params = new URLSearchParams(window.location.search);
    const utm: Record<string, string | null> = {};
    for (const key of ['source', 'medium', 'campaign', 'content']) utm[key] = clean(params.get(`utm_${key}`));
    utm.campaign_id = clean(params.get('utm_id')) || clean(params.get('campaign_id'));
    let referrerHost: string | null = null;
    if (document.referrer) {
      const referrer = new URL(document.referrer);
      if (referrer.hostname !== window.location.hostname) referrerHost = referrer.hostname;
    }
    const landings = ['/', '/start', '/register', '/login', '/pricing', '/upgrade', '/kundlistar', '/studio', '/studio/register'];
    const value: Attribution = { captured_at: Date.now(), platform: 'web', source: utm.source ? 'campaign' : referrerHost ? 'referral' : 'direct', evidence: 'web_first_visit',
      utm, referrer_host: referrerHost, landing_path: landings.includes(window.location.pathname) ? window.location.pathname : null };
    localStorage.setItem(KEY, JSON.stringify(value));
  } catch { /* Storage restrictions must not block registration. */ }
}
export function registrationAttribution(): Partial<Attribution> {
  captureRegistrationAttribution();
  try { return JSON.parse(localStorage.getItem(KEY) || 'null') || { platform: 'web', source: 'unknown' }; }
  catch { return { platform: 'web', source: 'unknown' }; }
}
